export const heroContent = {
  heading: "Precision Hiring for Serious Organisations.",
  highlight: "Full hire",
  subheading:
    "Every shortlist is sharper, and every hire is better.",
  primaryButton: {
    text: "Get started",
    link: "/login",
  },
  secondaryButton: {
    text: "Book a demo",
    link: "/about",
  },
  imageSrc: "/images/hero.png",
  imageAlt: "Hero",
}


export const featuresContent = {
  heading: "Features",
  subheading: "Everything you need to succeed",
  description:
    "Tempered Talent is an all-in-one Software, combining advanced automation, predictive intelligence, for recruitment and onboarding.",
  features: [
    {
      name: "AI-Powered Automation",
      description:
        "Automate the recruitment processs from job posting to candidate screening with intelligent AI tools.",
    },
    {
      name: "AI assisted Job generation and Posting",
      description:
        "Easy to create and post job listings across multiple platforms with AI assistance to attract top talent.",
    },
    {
      name: "Advanced Analytics",
      description:
        "Get insights on top candidates, recruitment trends, and hiring performance with our comprehensive analytics dashboard.",
    },
  ],
}

export const howItWorksContent = {
  heading: "How it works",
  subheading:
    "Simple steps to transform your recruitment process with Tempered Talent.",
  steps: [
    {
      name: "Create Job Postings",
      description:
        "Use our AI-powered tools to create compelling job descriptions and post them across multiple platforms.",
    },
    {
      name: "Screen Candidates",
      description:
        "Our intelligent system automatically screens applications and ranks candidates based on qualifications.",
    },
    {
      name: "Hire & Onboard",
      description:
        "Streamline the hiring process and onboard new employees with automated workflows and documentation.",
    },
  ],
}

export const testimonialsContent = {
  heading: "Testimonials",
  subheading: "Trusted by developers worldwide",
  testimonials: [
    {
      quote:
        "This tool has transformed how we work. The AI automation saves us hours every week.",
      author: "Sarah Johnson, CTO at TechCorp",
    },
    {
      quote:
        "Finally, an AI assistant that actually understands what I need. Game changer!",
      author: "Michael Chen, Product Manager",
    },
    {
      quote:
        "The collaboration features are incredible. Our team productivity has doubled.",
      author: "Emily Davis, Team Lead",
    },
  ],
}

export const pricingContent = {
  heading:
    "With concepts in hand, we meticulously design, refining every detail to align with your vision and objectives.",
  plans: [
    {
      name: "Talent Recruitment",
      price: {
        monthly: "R4500",
        yearly: "1200",
      },
      billing: "Billed annually",
      features: [
        "14 days trail",
        "Up to 3 individual users",
        "Talent recruitment only",
        "10% for credits"
      ],
    },
    {
      name: "Full Hire Suite",
      price: {
        monthly: "R5500",
        yearly: "R3400",
      },
      billing: "Billed annually",
      popular: true,
      features: [
        "14 days trail",
        "Up to 3 individual users",
        "All recruitment and onboarding features",
        "10% for credits"
      ],
    },
    {
      name: "Employee Onboarding",
      price: {
        monthly: "R2500",
        yearly: "R2200",
      },
      billing: "Billed annually",
      features: [
        "14 days trail",
        "Up to 3 individual users",
        "Employee onboarding only",
        "500 onboards per month",
        "10% for credits"
      ],
    },
  ],
}

export const ctaContent = {
  heading: "Ready to get started?",
  subheading:
    "Join thousands of users who have transformed their workflow with our AI-powered platform.",
  primaryButton: {
    text: "Start free trial",
    link: "/login",
  },
  secondaryButton: {
    text: "Contact sales",
    link: "/contact",
  },
}

export const privacyContent = {
  heading: "Your data, your control",
  subheading:
    "We prioritize your privacy and security with enterprise-grade protection.",
  features: [
    {
      name: "End-to-end encryption",
      description:
        "All your data is encrypted in transit and at rest using industry-standard protocols.",
    },
    {
      name: "SOC 2 compliant",
      description:
        "We maintain the highest security standards with regular audits and compliance checks.",
    },
    {
      name: "Data portability",
      description:
        "Export your data anytime. You're never locked into our platform.",
    },
  ],
}
